import { SET_TRANSLATED_COLUMN_LISTS } from '../actions/TranslatedColumnListsActions';

const initialState = {};

const translatedColumnListsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSLATED_COLUMN_LISTS:
      return {
        ...state,
        ...action.payload.data,
      };

    default:
      return state;
  }
};

export default translatedColumnListsReducer;
